import { ref, Ref, inject, readonly } from 'vue';
import { setOrganizationGetter } from '@/utils/api_client/sreshine/axios';

// 型定義
export interface CurrentOrganization {
  label?: string;
  tenantId?: number;
}

// 初期値 (URLにパラメータがあればそれらをセットする)
const parseQueryFromWindow = (): CurrentOrganization => {
  const search = window.location.search;
  const params = new URLSearchParams(search);

  return {
    label: params.get('organization') || undefined,
  };
};

// State
const currentOrganization: Ref<CurrentOrganization> = ref(
  parseQueryFromWindow()
);

// Provider
export const createCurrentOrganization = () => {
  return {
    currentOrganization,
  };
};

export const getCurrentOrganizationLabel = (): string => {
  return currentOrganization.value.label || '';
};

export const getCurrentTenantId = (): string => {
  const tenantId = currentOrganization.value.tenantId;
  return tenantId !== undefined ? String(tenantId) : '';
};

setOrganizationGetter(getCurrentOrganizationLabel);

// localStorage のキャッシュ値を優先し、なければ先頭組織を返す
export const resolveOrganizationByCache = <T extends { label?: string }>(
  organizations: T[],
  cachedLabel: string | null
): T | undefined => {
  const cached = cachedLabel
    ? organizations.find((o) => o.label === cachedLabel)
    : undefined;
  return cached ?? organizations[0];
};

// Inject
export const keyCurrentOrganization = Symbol();
export const useCurrentOrganization = () => {
  const { currentOrganization: injectedOrganization } = inject(
    keyCurrentOrganization
  ) as {
    currentOrganization: Ref<CurrentOrganization>;
  };
  const setCurrentOrganization = (
    label: string | undefined,
    tenantId?: number
  ) => {
    injectedOrganization.value.label = label;
    injectedOrganization.value.tenantId = tenantId;
  };

  return {
    currentOrganization: readonly(injectedOrganization),
    setCurrentOrganization,
    getCurrentOrganizationLabel,
    getCurrentTenantId,
  };
};
